import React from 'react';
import { View, StyleSheet } from 'react-native';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';

const StarFilledIcon = RESIDENTS_SVG_COMPONENTS.MARKETPLACE_STAR;
const StarGrayIcon = RESIDENTS_SVG_COMPONENTS.STAR_GRAY;

interface StarRatingProps {
  rating: number;
  size?: number;
}

/**
 * StarRating - Display-only star rating component
 * Uses filled yellow stars for the rating value and gray stars for the rest.
 * Supports decimal ratings (e.g., 3.5 shows 3 filled stars).
 */
export const StarRating: React.FC<StarRatingProps> = ({ 
  rating, 
  size = 20,
}) => {
  const stars = [];
  const filledCount = Math.floor(rating); // Round down for filled stars
  
  for (let i = 0; i < 5; i++) {
    const isFilled = i < filledCount;
    const Icon = isFilled ? StarFilledIcon : StarGrayIcon;
    
    stars.push(
      <Icon
        key={i}
        width={size}
        height={size}
      />
    );
  }
  return (
    <View 
      style={styles.container}
      accessibilityRole="text"
      accessibilityLabel={`Rating: ${rating} out of 5 stars`}
    >
      {stars}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 2,
  },
});

